/**
 * useQueryParams Hook
 */
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { parseCheckoutParams, type CheckoutParams } from '../utils/queryParamParser';

export function useQueryParams() {
  const [searchParams] = useSearchParams();

  const result = useMemo(() => {
    const { params, errors } = parseCheckoutParams(searchParams);
    return {
      params,
      errors,
      isValid: errors.length === 0 && params !== null,
    };
  }, [searchParams]);

  return result as {
    params: CheckoutParams | null;
    errors: string[];
    isValid: boolean;
  };
}
